package com.trevorwiebe.timesheet.loads.presentation.admin

import com.trevorwiebe.timesheet.core.domain.Util
import kotlinx.datetime.LocalDate

data class LoadsFilter(
    val customerId: String? = null,
    val employeeId: String? = null,
    val carrierId: String? = null,
    val pickupLocationId: String? = null,
    val dropLocationId: String? = null,
    val startDate: LocalDate = Util.lastTwoMonthsRange().first,
    val endDate: LocalDate = Util.lastTwoMonthsRange().second,
    val showStartPicker: Boolean = false,
    val showEndPicker: Boolean = false,
)
